
export const examplesResponse = [
  {
    id: 1,
    name: 'Christmas Packing Slip 2023',
    lastUpdated: '2023-04-03T21:41:22.768Z',
    active: true,
    giftNoteEnabled: true,
    giftNotePlacement: 'left',
    logoAttachmentId: 'f08e36d0-851f-4b73-8463-fef31fe520d4',
    logoPlacement: 'left',
    customMessage: '<strong>Test Text!</strong>',
  },
  {
    id: 2,
    name: 'Summer Sale 2023',
    lastUpdated: '2023-04-05T21:41:22.768Z',
    active: false,
    giftNoteEnabled: false,
    giftNotePlacement: 'left',
    logoAttachmentId: 'f08e36d0-851f-4b73-8463-fef31fe520d4',
    logoPlacement: 'left',
    customMessage: '<strong>Test Text 2!</strong>',
  },
  {
    id: 3,
    name: 'Fall Fashion Sale 2023',
    lastUpdated: '2023-04-02T21:41:22.768Z',
    active: false,
    giftNoteEnabled: true,
    giftNotePlacement: 'left',
    logoAttachmentId: 'f08e36d0-851f-4b73-8463-fef31fe520d4',
    logoPlacement: 'left',
    customMessage: '<strong>Test Text 3!</strong>',
  },
  {
    id: 4,
    name: 'Black Friday Sale 2023',
    lastUpdated: '2023-03-25T21:41:22.768Z',
    active: false,
    giftNoteEnabled: true,
    giftNotePlacement: 'left',
    logoAttachmentId: 'f08e36d0-851f-4b73-8463-fef31fe520d4',
    logoPlacement: 'left',
    customMessage: '<strong>Test Text 4!</strong>',
  },
  {
    id: 5,
    name: 'Independence Day Discount',
    lastUpdated: '2023-03-20T21:41:22.768Z',
    active: false,
    giftNoteEnabled: true,
    giftNotePlacement: 'left',
    logoAttachmentId: 'f08e36d0-851f-4b73-8463-fef31fe520d4',
    logoPlacement: 'left',
    customMessage: '<strong>Test Text 5!</strong>',
  },
]